import {
	DownloadOutlined,
	HomeOutlined,
	SafetyCertificateOutlined,
} from "@ant-design/icons";
import { BodhiButton } from "@bodhistreams/ui";
import "./CertificateHeader.css";

const CertificateHeader = ({ onBack, onDownload }) => {
	return (
		<div className="cert-header">
			<div className="cert-header-body">
				<div>
					<p className="cert-eyebrow">
						<SafetyCertificateOutlined />
						Direct License
					</p>
					<h1 className="cert-title">Direct License Certificate</h1>
					<p className="cert-subtitle">
						Prepare the business details for your venue, review the live
						certificate preview, and download a PDF for your records.
					</p>
				</div>
				<div className="cert-actions">
					<BodhiButton variant="ghost" icon={<HomeOutlined />} onClick={onBack}>
						Back to Profile
					</BodhiButton>
					<BodhiButton
						variant="primary"
						icon={<DownloadOutlined />}
						onClick={onDownload}
					>
						Download PDF
					</BodhiButton>
				</div>
			</div>
		</div>
	);
};

export default CertificateHeader;
